import { FC, SVGProps } from 'react';

const PDFIcon: FC<SVGProps<SVGSVGElement>> = ({
  height = 24,
  width = 24,
  ...props
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={width}
      height={height}
      viewBox="0 0 13 17"
      version="1.1"
      {...props}
    >
      <g
        id="Chat-Message-Variants"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="PDF[Left]-Copy-3"
          transform="translate(-38.000000, -185.000000)"
          fillRule="nonzero"
        >
          <g id="icons8-pdf" transform="translate(38.000000, 185.000000)">
            <polygon
              id="Path"
              fill="#FF5722"
              points="12.952381 17 0 17 0 0 8.9047619 0 12.952381 4.04761905"
            />
            <polygon
              id="Path"
              fill="#FBE9E7"
              points="12.3452381 4.45238095 8.5 4.45238095 8.5 0.607142857"
            />
            <path
              d="M3.16119048,10.7261905 L3.16119048,12.1428571 L2.34761905,12.1428571 L2.34761905,8.1142619 L3.72016667,8.1142619 C4.11845238,8.1142619 4.43659524,8.23811905 4.67338095,8.48502381 C4.91016667,8.73192857 5.0287619,9.05290476 5.0287619,9.44795238 C5.0287619,9.843 4.91138095,10.1542619 4.67742857,10.3833571 C4.44347619,10.6124524 4.11845238,10.7261905 3.70316667,10.7261905 L3.16119048,10.7261905 Z M3.16119048,10.0482143 L3.72016667,10.0482143 C3.87519048,10.0482143 3.995,9.99761905 4.08,9.89602381 C4.165,9.79442857 4.20709524,9.64709524 4.20709524,9.45321429 C4.20709524,9.25204762 4.16378571,9.09216667 4.07716667,8.9727619 C3.99054762,8.85416667 3.87438095,8.79385714 3.72866667,8.79183333 L3.16119048,8.79183333 L3.16119048,10.0482143 Z M5.57114286,12.1428571 L5.57114286,8.1142619 L6.63647619,8.1142619 C7.10680952,8.1142619 7.48202381,8.26361905 7.76090476,8.56233333 C8.04059524,8.86104762 8.18307143,9.27066667 8.1887381,9.79078571 L8.1887381,10.4436667 C8.1887381,10.9730952 8.04869048,11.3887857 7.76980952,11.6899286 C7.48971429,11.9922857 7.10478571,12.1428571 6.61421429,12.1428571 L5.57114286,12.1428571 Z M6.38430952,8.7922381 L6.38430952,11.4677143 L6.62797619,11.4677143 C6.89916667,11.4677143 7.09021429,11.3960714 7.20071429,11.2531905 C7.31121429,11.1103095 7.3695,10.8638095 7.37516667,10.5132857 L7.37516667,9.81345238 C7.37516667,9.43702381 7.32254762,9.1747381 7.21730952,9.02659524 C7.11207143,8.87804762 6.93316667,8.79992857 6.68059524,8.79264286 L6.38430952,8.79264286 L6.38430952,8.7922381 Z M10.8504524,10.499119 L9.58597619,10.499119 L9.58597619,12.1428571 L8.77240476,12.1428571 L8.77240476,8.1142619 L11.0026429,8.1142619 L11.0026429,8.7922381 L9.58597619,8.7922381 L9.58597619,9.82438095 L10.8504524,9.82438095 L10.8504524,10.499119 Z"
              id="Shape"
              fill="#FFEBEE"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export default PDFIcon;
